import React from 'react';
import styled, { css } from 'styled-components';
import { LazyPicture } from '@catalogo/theme-lazy-picture';

const Options = ({ values }) => {
  if (values.length <= 1) {
    return null;
  }

  return (
    <Wrapper>
      {values.map(({ value, key, hasImage, image, isSelected, hasOffer, handleSelectOption }) =>
        hasImage ? (
          <OptionImg isSelected={isSelected} hasOffer={hasOffer} key={key} onClick={handleSelectOption}>
            <LazyPicture sources={{ mobile: { src: image, ratio: '1:1' }, desktop: { src: image, ratio: '1:1' } }} />
            {!hasOffer && <CrossLine />}
          </OptionImg>
        ) : (
          <OptionText isSelected={isSelected} hasOffer={hasOffer} key={key} onClick={handleSelectOption}>
            {value}
            {!hasOffer && <CrossLine />}
          </OptionText>
        )
      )}
    </Wrapper>
  );
};
const Wrapper = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  padding-bottom: 10px;

  @media (min-width: 769px) {
    padding-bottom: 0;
    max-width: 410px;
    flex-wrap: wrap;
  }
`;

const Option = css`
  position: relative;
  cursor: pointer;
  display: flex;
  opacity: ${({ hasOffer }) => (hasOffer ? 1 : 0.15)};
  border: 1px solid ${({ isSelected }) => (isSelected ? '#333' : '#ccc')};
  border-radius: 3px;
  margin: 8px 8px 0 0;
`;

const CrossLine = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to bottom right,
    transparent calc(50% - 1px),
    #666 calc(50% - 1px),
    #666 50%,
    transparent 50%
  );
`;

const OptionImg = styled.div`
  ${Option}
  padding: 3px 7px;
  height: 56px;
  min-width: 64px;
`;

const OptionText = styled.div`
  ${Option}
  align-items: center;
  justify-content: center;
  min-width: 44px;
  padding: 8px 16px;
  flex: 0 0 auto;
  height: 32px;
`;

export default Options;
